class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
    this.cartDrawer = document.querySelector('cart-drawer');
    this.quantitySelector = document.querySelector('quantity-calculator');
  }

  onSubmitHandler(evt) {
    let self = this;
    evt.preventDefault();

    this.minQuantity = this.quantitySelector
      .querySelector('input#field-minimum-quantity')
      .getAttribute('min');

    this.currentQuantity = this.quantitySelector.querySelector(
      'input#field-minimum-quantity'
    ).value;

    if (parseInt(this.minQuantity) > parseInt(this.currentQuantity)) {
      this.cartNotification.renderQuantityError(this.minQuantity);
      return;
    }

    const submitButton = this.querySelector('[type="submit"]');
    let submitButtons = [submitButton];

    if (document.querySelector('[data-sticky-add-to-cart]')) {
      submitButtons.push(document.querySelector('[data-sticky-add-to-cart]'));
    }

    submitButtons.forEach((button) => {
      button.setAttribute('disabled', true);
      button.classList.add('button--loading');
    });

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const cartDrawerSections = ['cart-drawer', 'cart-icon-bubble'];

    const sectionsToFetch = [
      ...cartDrawerSections,
      ...this.cartNotification.getSectionsToRender().map((section) => section.id),
    ];

    const formData = new FormData(this.form);
    formData.append('sections', sectionsToFetch);
    formData.append('sections_url', window.Shopify.routes.root);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.status == 422) {
          this.cartNotification.setActiveElement(document.activeElement);
          this.cartNotification.renderQuantityError(formData.get('inventory_quantity'));
          return;
        }

        if (window.crossSellItems?.length > 0) {
          const crossSellFormData = {
            items: window.crossSellItems,
            sections: sectionsToFetch.join(','),
          };
          fetch(`${routes.cart_add_url}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(crossSellFormData),
          })
            .then((response) => {
              return response.json();
            })
            .then((parsedState) => {
              if (parsedState.status == 422) {
                this.cartNotification.setActiveElement(document.activeElement);
                this.cartNotification.renderQuantityError(formData.get('inventory_quantity'));
                return;
              }

              if (this.cartDrawer) this.cartDrawer.renderContents(parsedState);
            })
            .catch((error) => {
              console.error('Error:', error);
            });
        } else {
          if (this.cartDrawer) this.cartDrawer.renderContents(parsedState);
        }

        switch (submitButton.dataset.addToCartBehavior) {
          case 'open_cart_drawer':
            setTimeout(() => {
              if (this.cartDrawer) this.cartDrawer.open();
            });
            break;
          case 'show_cart_notification':
          default:
            this.cartNotification.setActiveElement(document.activeElement);
            this.cartNotification.renderContents(parsedState);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButtons.forEach((button) => {
          button.classList.remove('button--loading');
          button.removeAttribute('disabled');
        });
      });
  }
}

window.ProductForm = ProductForm;
customElements.define('product-form', ProductForm);
